import { render, staticRenderFns } from "./yexiu.vue?vue&type=template&id=24aa5665&scoped=true&"
import script from "./yexiu.vue?vue&type=script&lang=js&"
export * from "./yexiu.vue?vue&type=script&lang=js&"
import style0 from "./yexiu.vue?vue&type=style&index=0&id=24aa5665&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa5665",
  null
  
)

export default component.exports